// Google Analytics 4 (GA4) pour le SPA.
//
// Contexte : GA4 (G-5Z9R61JSCH) n'etait charge que sur le site marketing Next
// (callizy.ca). Depuis le cutover, tout le funnel d'inscription vit sur le SPA
// (app.callizy.ca) qui n'avait aucune balise -> plus aucun page_view -> l'event
// `signup_complete` (regle GA4 calee sur "page_location contient /onboarding/step1")
// ne se declenchait plus. Ce module recharge GA4 sur le SPA et emet un page_view
// explicite a chaque changement de route (cf. LocaleLayout).
//
// Cross-domain : les deux domaines (callizy.ca + app.callizy.ca) sont declares
// dans GA4 (Admin > Flux de donnees > Configurer vos domaines), donc gtag propage
// le client_id via `_gl` lors du passage marketing -> app. Rien a faire cote code.
//
// No-op si VITE_GA_MEASUREMENT_ID est absent (ex: dev local) : aucune telemetrie
// GA4 depuis localhost, donc pas de fausses conversions en test.

declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

let initialized = false

// Charge gtag.js + config GA4. Idempotent. No-op sans MEASUREMENT_ID.
export function initGA(): void {
  if (initialized || !MEASUREMENT_ID || typeof window === 'undefined') return
  initialized = true

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // Signature officielle gtag : pousse `arguments` tel quel dans dataLayer.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  // send_page_view: false -> on pilote les page_view au changement de route
  // React Router (sinon double comptage avec le page_view automatique de gtag).
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
  })
}

// Emet un page_view explicite. page_location = URL absolue complete pour que la
// regle GA4 "page_location contient /onboarding/step1" matche correctement.
export function gaPageView(path: string): void {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return
  }
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}

// Identifiant GA4 du visiteur (client_id), lu dans le cookie `_ga` (« GA1.1.<id>.<horodatage> »).
// Envoyé au backend au passage par Stripe et rangé dans l'abonnement : le webhook du
// premier paiement le renvoie à GA4 (conversion `premier_paiement`), qui le relie au
// clic publicitaire d'origine. Undefined si GA4 n'a pas posé de cookie (refus, dev).
export function gaClientId(): string | undefined {
  if (typeof document === 'undefined') return undefined
  const m = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)/)
  return m ? m[1] : undefined
}
